module.exports = __webpack_public_path__ + "img/grand-room.252f5184.jpg";